import { Guid } from "@/Common/Models/Guid";
import { MedicalItemTypeEnum } from "@/Patient/Models/MedicalSummary/Enum/MedicalItemTypeEnum";
import { MedicalItem } from "./MedicalItem";

class MedicalItemImmunization extends MedicalItem {
    public AdministeredDate: Date;
    public RefusedDate: Date;
    public LotNumber: string;
    public Name: string;
    public Type: string;
    public Manufacturer: string;
    public RouteCode: string;
    public Instruction: string;
    public IsRefused: boolean;
    public Dose: number;
    public AdministeredPrecisionDate: number;
    public RefusedPrecisionDate: number;
    public BoosterInMonth: number;
    public SiteLookupId: string;
    public SiteLookupValue: string;
    public DoseUnitLookupId: string;
    public DoseUnitLookupValue: string;
    public SubmittedToQuebecRegistryOn: Date | null;
    public SubmittedToQuebecRegistryBy: string | null;

    // Quebec Vaccination Registry Data
    public AdministeredByDisplayText: string;
    public LocationDisplayText: string;
    public QuebecRegistryId: number;
    public QuebecRegistryAdministeredById: number;
    public QuebecRegistryAdministeredByDisplayText: string;
    public QuebecRegistryLocationId: number;
    public QuebecRegistryDoseUnitCode: string;
    public QuebecRegistrySiteCode: string;
    public QuebecRegistryLotId: number;
    public QuebecRegistryAdministeredReasonCode: string;
    public QuebecRegistryAgentCode: string;
    public QuebecRegistryExpirationDate: Date;
    public QuebecRegistryRefusalMotiveCode: string;
    public IsQuebecRegistryForm: boolean;
    public QuebecRegistryAntigenCodes: string;
    public IsQuebecRegistryAllAntigensSelected: boolean;
    public QuebecRegistryVersion: string;
    public QuebecRegistryDeletionDate: Date;
    public IsQuebecRegistryHistoricalVaccine: boolean;
    public VaccinatorEmployeeId: string;

    // UI
    public isSyncing: boolean = false;

    public constructor(init?: Partial<MedicalItemImmunization>) {
        super();
        Object.assign(this, init);
    }

    public static newImmunization(encounterId: Guid): MedicalItemImmunization {
        return new MedicalItemImmunization({
            ...MedicalItem.newItem(encounterId, MedicalItemTypeEnum.Immunization),
            LotNumber: "",
            Manufacturer: "",
            Type: "",
            Name: "",
            QuebecRegistrySiteCode: "",
            RouteCode: "",
            Dose: null,
            QuebecRegistryDoseUnitCode: "",
            QuebecRegistryAdministeredReasonCode: ""
        });
    }
}

export { MedicalItemImmunization };
